import React from 'react';
import { isAdminOnlyDoc } from '../../../../utils/docTags';
import { DocSheetCloseButton } from '../../DocSheetCloseButton';
import DocFolderMenu from './DocFolderMenu';

const DocFullPageTopbar = ({
  backLabel,
  onBack,
  onClose,
  doc,
  organization,
  docId,
  isAdmin,
  onToggleAdminOnly,
}) => (
  <div className="doc-fullpage__topbar">
    <button className="doc-fullpage__back" onClick={onBack}>
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
      </svg>
      <span className="doc-fullpage__back-label">{backLabel}</span>
    </button>
    <div className="doc-fullpage__topbar-end">
      {doc && organization && (
        <DocFolderMenu organization={organization} docId={docId} />
      )}
      {doc && isAdmin && (
        <button
          className={`doc-fullpage__perm-toggle ${isAdminOnlyDoc(doc) ? 'is-admin-only' : ''}`}
          onClick={onToggleAdminOnly}
          title={
            isAdminOnlyDoc(doc)
              ? 'Visible to admins only — click to make visible to everyone'
              : 'Visible to everyone — click to restrict to admins'
          }
        >
          {isAdminOnlyDoc(doc) ? 'Admin only' : 'Everyone'}
        </button>
      )}
      <DocSheetCloseButton onClose={onClose} />
    </div>
  </div>
);

export default DocFullPageTopbar;
